
import { getSeconds, deliveryRecord, setDoupOrder, stockList, whList, deliveryOrderInfo, deliveryOrderClose, getTphendlist,getWallet, contractOrderList,cancelOrder, getTpmicrolist, contractTrade, getleverList, deliverySubmit, getCoinInfo, closeOrder } from '../service/getdata'
import {mapState,mapMutations} from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import AmountSlider from "../components/amountSlider.vue";
export default{
data(){
return{
msg: "",

show: false,
name: "",
type: 1,
setWin:false,
profit_price: "", //止盈价格
winid: "", //止盈止损订单id
loss_price: "", //止损价格
open_type: 1,
value2: 1,
option2: [{
text:this.$t('市价'),
value: 1
},{
text: this.$t('限价'),
value: 2
}],
position_type: 1,
secondList: [], //交割时间列表
seconds: null, //选中的交割时间id
levelList: [], //倍数列表
level: "", //选中的倍数id
yxList: [], //左侧列表数据
timeout: null,
showLeftList: false, //左侧列表是否展示
listLoading: false,
number: "",
showDelivery: false,
settlementPopup: false,
currentRate: 0,
rate: 0,
deliveryInfo: {}, //存放秒合约交易弹窗数据
timerInfo: null,
coinInfo: {}, //买卖五档
shuliang: "", //开仓数量
price: "", //开仓价格
levelTxt: "",//选中的倍数文字
holdList: [], //持有列表
orderType: 1, //0委托,1持有 2历史
status: 1, //1持有 3历史
timeout2: null,
trade_type: "2" ,//1货币 2期货 3股票
settlementInfo: {}, //结算弹窗数据
pid: "",
code: "",
min_buy: "", //最低金额
nation: "",
settlementing: true,
userInfo:{},
qihuoFirst:{},//期货第一个

countDown:null
}
},
components:{
Toast,
AmountSlider,
XHeader
},
computed:{
...mapState(['url','token']),
timeFormat () {
let res='--'
if (!parseInt((this.countDown*1000 - Date.parse(new Date())) / 1000)) {
return '--'
}
if (parseInt((this.countDown*1000 - Date.parse(new Date())) / 1000)>86400) {
res = 'DDd HHh mmm sss'
} else {
res = 'sss'
}
return res
},
},
mounted() {



},
created(){

console.log('爱睡觉的哈吉斯的',this.$route.query)

const {  trade_type,status,type } = this.$route.query

this.trade_type = trade_type|| '2'
this.SETTOKEN()
this.name = this.$route.query.name || ''
this.type = type || 2
this.open_type = this.$route.query.stype || 1
this.pid = this.$route.query.pid || ''
this.code = this.$route.query.code || ''
this.nation = this.$route.query.nation || ''

if(this.name){
if(this.type == 1){
this.getLeverData()


}else{
this.position_type=3
this.getSecondsData()
this.getDeliveryRecord()
}

this.$nextTick(()=>{
this.getCoinInfo()
})

return
}

if(this.trade_type == 2){
whList({ token: this.token}).then((res)=>{

this.qihuoFirst = res.data.data[0]

this.choice(  2 )

this.getCoinInfo()

if(this.type == 1){
this.getLeverData()


}else{
this.position_type=3
this.getSecondsData()
this.getDeliveryRecord()
}

})
}
else{
this.$nextTick(()=>{
this.getCoinInfo()
})
}

},
methods:{
...mapMutations(['GETRECENTBUY','SETTOKEN']),
goContract(type, trade_type, name, enter, code){
if(trade_type==1){
this.$router.push(`/pages/info?name=${!!name ? name : this.name}&type=${type}&trade_type=1&enter=${enter}`)
}else if(trade_type==2){
this.$router.push(`/pages/info?name=${!!name ? name : this.name}&type=${type}&trade_type=2&pid=${this.pid}&enter=${enter}`)
}else{
this.$router.push(`/pages/info?name=${!!name ? name : this.name}&type=${type}&trade_type=3&code=${!!name ? name : this.name}&nation=${this.nation}&enter=${enter}`)
}

},
getAmount(val) {
if (!val) {
val = ''
}
this.shuliang = val;
},
getAmount2(val) {
if (!val) {
val = ''
}
this.number = val;
},
choice(index){
this.trade_type = index;
if(index==1){
this.name= 'BTC'
}else if(index==2){
let name = this.qihuoFirst.ptitle
this.name = name
this.pid= this.qihuoFirst.id
this.code = name
}else{
this.name= 'APLE'
this.code = 'APLE'
this.nation="US"
this.flag="US"
}



},
goSpot(){
this.$router.push(`/pages/spot?name=${this.name}&trade_type=${this.trade_type}&code=${this.name}&flag=${this.nation}&enter=info`)
},
getYxOrderList(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}

contractOrderList({token: this.token,status: this.orderType, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = (res.data || []).map( i =>{




if(this.orderType == 1 && i.now_price > 0){
i.price = i.now_price
}





if(i.type == 1){

let yinkuilv = (i.price - i.origin_price) / i.origin_price
let yinkui = (yinkuilv * i.number).toFixed(2)

i.yinkuilv = yinkuilv
i.yinkui = yinkui
i.yinkuilvPer = (yinkuilv*100).toFixed(2)


}



else{

let yinkuilv = (i.origin_price - i.price) / i.origin_price
let yinkui = (yinkuilv * i.number).toFixed(2)

i.yinkuilv = yinkuilv
i.yinkui = yinkui
i.yinkuilvPer = (yinkuilv*100).toFixed(2)

}
return i
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}

console.log("error")
})
},
getDeliveryRecord(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}

deliveryRecord({token: this.token,status: this.status, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = (res.data || []).map( i =>{





if(this.status == 1 && i.now_price > 0){
i.price = i.now_price
}




if(i.type == 1){

let yinkuilv = (i.price - i.origin_price) / i.origin_price
let yinkui = (yinkuilv * i.number).toFixed(2)

i.yinkuilv = yinkuilv
i.yinkui = yinkui
i.yinkuilvPer = (yinkuilv*100).toFixed(2)


}



else{

let yinkuilv = (i.origin_price - i.price) / i.origin_price
let yinkui = (yinkuilv * i.number).toFixed(2)

i.yinkuilv = yinkuilv
i.yinkui = yinkui
i.yinkuilvPer = (yinkuilv*100).toFixed(2)

}
return i
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
})
},
goHistory(){
if(this.type==1){
this.$router.push(`/pages/perpetualHistory?trade_type=${this.trade_type}`)
}else{
this.$router.push(`/pages/deliveryContractHistory?trade_type=${this.trade_type}`)
}
},
trade(type){
if(!this.shuliang || this.shuliang=='' || this.shuliang=='0'){
this.sendMsg(this.$t('请输入开仓金额'))
return
}
if(this.value2==2 && ( !this.price || this.price=='' || this.price=='0')){
this.sendMsg(this.$t('请输入开仓价格'))
return
}
const that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行该操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.confirmTrade(type)
}
})
},
confirmTrade(type){


var that = this
this.$Loading()
contractTrade({token: this.token, type, symbol:this.name,  number: this.shuliang, seconds: this.level, price: this.price, ptype: this.value2, trade_type: this.trade_type, flag:this.nation}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(res.message)
that.getYxOrderList(true)
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()


console.log("error")
})
},
setWinId(id){
this.winid=id
this.setWin = true
},
addProfitPrice(){
this.profit_price = Number(this.profit_price+1)
},
addLossPrice(){
this.loss_price = Number(this.loss_price+1)
},
minusProfitPrice(){
if(this.profit_price==0){
return
}
this.profit_price = Number(this.profit_price-1)
},
minusLossPrice(){
if(this.loss_price==0){
return
}
this.loss_price = Number(this.loss_price-1)
},
setWinSave(){
if(this.profit_price==''){
this.sendMsg(this.$t("请输入止盈价格"))
return
}
if(this.loss_price==''){
this.sendMsg(this.$t("请输入止损价格"))
return
}
const that = this
that.$Loading()

setDoupOrder({token: that.token, id: this.winid, profit_price: that.profit_price, loss_price: this.loss_price,trade_type: this.trade_type,}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
cancelOrder(id){
var that = this

this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行撤单操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
cancelOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
}
})

},
closeOrder(id){
var that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行平仓操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
closeOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
}
})

},
getCoinInfo() { // 获取数据


clearInterval(this.timerInfo)
this.timerInfo = null
clearInterval(this.timeout2)
this.timeout2 = null
this.getIntervalCoin()
this.timerInfo = setInterval(() => {
this.getIntervalCoin()
}, 2000);
},


getIntervalCoin(){


const that = this
















if(this.type==1){
this.getYxOrderList()
}else{
this.getDeliveryRecord()
}
},
delivery(type){
if(!this.number || this.number=='' || this.number=='0'){
this.sendMsg(this.$t("请输入开仓金额"))
return
}

const that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行该操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.confirmDelivery(type)
}
})


},
confirmDelivery(type){
var that = this
this.$Loading()
deliverySubmit({token: this.token, type,   symbol: this.name, seconds: this.seconds, number: this.number, trade_type: this.trade_type, flag:this.nation}).then(function(res){
var res = res.data;

console.log('哈哈哈哈',res)

that.$Loading.close()
if(res.status=='1'){
that.showDelivery=true
that.deliveryInfo = res.data



this.countDown = Date.now()/1000 +  res.data.endprofit


clearInterval(that.timeout2)
that.timeout2 = null
that.timeout2 = setInterval(() => {
that.deliveryDetail(that.deliveryInfo.id)
}, 1000);
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()


console.log("error")
})
},


getSecondsData(){
var that = this
this.$Loading()
getSeconds({token: this.token, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.secondList = res.data
that.seconds = res.data[0].id
that.min_buy = res.data[0].min_buy
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},

getLeverData(){
var that = this
this.$Loading()
that.levelList=[]
getleverList({token: this.token, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
res.data.forEach(ele => {
that.levelList.push({text: ele.seconds+'x', value: ele.id})
console.log(ele.seconds)

});
that.level = res.data[0].id
that.levelTxt = res.data[0].seconds

}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},


deliveryDetail(id,isLoading){

var that = this
if(!!isLoading){
this.$Loading()
}

deliveryOrderInfo({token: this.token, id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.deliveryInfo = res.data[0]

}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
})
},


getYxList(){
var that = this
that.showLeftList = true
this.listLoading = true
this.timeout = setInterval(() => {
if(this.trade_type=='1'){
if(this.type==1){
getTphendlist({ token: this.token}).then(function(res){
var res = res.data;
that.listLoading = false
if(res.status=='1'){

that.yxList = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){

console.log("error")
})
}else{
getTpmicrolist({ token: this.token}).then(function(res){
var res = res.data;
that.listLoading = false
if(res.status=='1'){
that.yxList = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){

console.log("error")
})
}
}else if(this.trade_type=='2'){
whList({ token: this.token}).then(function(res){
var res = res.data;
that.listLoading = false
that.yxList = res.data
}.bind(this),function(){

console.log("error")
})
}else{
stockList({token: this.token, type: this.sort, lang: this.nation}).then(function(res){
var res = res.data;
that.listLoading = false
that.yxList = res.data
}.bind(this),function(){
if(isLoading){

}
console.log("error")
})
}


}, 2000);
},
onchange(e){
const that = this
that.levelList.forEach(item=>{
if(item.value==e){
that.levelTxt = item.text.substr(0,item.text.length-1)
console.log(that.levelTxt)
}
})
},
chooseCoin(name,ptitle){
this.showLeftList = false
if(this.trade_type=='2'){
this.name = ptitle
}else{
this.name = name
}



},
onClose() {
clearInterval(this.timeout)
this.timeout = null
},
clearTimer() { //清楚定时器

clearInterval(this.timeout)
this.timeout = null
clearInterval(this.timerInfo)
this.timerInfo = null
clearInterval(this.timeout2)
this.timeout2 = null
},

sendMsg(content) {
this.msg = content;
this.show = true;
},
closeDelivery(){
clearInterval(this.timeout2)
this.timeout2 = null
this.showDelivery = false

},
handleFinish() {
},

timeChange(time) {
let temp = time.days * 86400 + time.hours * 3600 + time.minutes * 60 + time.seconds
this.rate = ((temp) / ((this.deliveryInfo.seconds) )) * 100
},


settlement(isLoading){

var that = this
if(!!isLoading){
this.$Loading()
}

deliveryOrderClose({token: this.token, id: this.deliveryInfo.id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()

}
if(res.status=='1'){
that.settlementInfo = res.data
that.settlementing= false

}else if(res.status=='0'){
that.settlement(false)
that.settlementing= true
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
that.$router.push("/pages/login")
console.log("error")
})
},

},
watch:{
rate: {
handler(curVal, oldVal) {
if(this.rate==0){
clearInterval(this.timeout2)
this.timeout2 = null
this.showDelivery = false

this.settlement(true)
}


},
deep: true
},

},

deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},

}



// WEBPACK FOOTER //
// ./src/pages/contractPosition.vue